import { Button, Modal, Input, Spin } from "antd";
import Text from "components/Text";
import styled from "styled-components";
import { CloseCircleFilled } from '@ant-design/icons';

// Utils
import { post, } from "library/endpoints";
import { useState } from "react";


const StyledLayer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 990;
  position: absolute;
  opacity: 0.9;
  background: black;
  top: 0;
  left: 0;
`;

const StyledContent = styled.div`
  position: absolute;
  z-index: 999;
  text-align: center;
  width: 100%;

  @media screen and (min-width: 960px) {
    img {
      width: 50% !important;
    }
  }
`;

/**
 * IkomMountQuotationsModal
 * @param {*} props 
 * @returns 
 */
const IkomMountQuotationsModal = (props) => {
  const [displayRefuseReasonModal, setDisplayRefuseReasonModal] = useState(false);
  const [refuseReason, setRefuseReason] = useState(null);
  const [loading, setLoading] = useState(false);

  if (!props.mount) {
    return null
  }

  const imgSrc = `${process.env.REACT_APP_S3_FILES_URL}${props.mount.output}`

  let mountName = '';

  const handleOnAccept = async (mount) => {
    try {
      setLoading(true)
      await post(`/frontend/mount-quotations/accept/${mount._id}`)
      setLoading(false)
      props.handleOnClose()
      props.fetchMountQuotations()
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const handleOnRefuse = async (mount) => {
    try {
      await post(`/frontend/mount-quotations/refuse/${mount._id}`, {
        refuse_reason: refuseReason
      })
      props.handleOnClose()
      props.fetchMountQuotations()
    } catch (error) {
      console.log(error)
    }
  }


  if (props.mount.support && props.mount.variant) {
    mountName = `${props.mount.support.name_fr} - ${props.mount.variant.name_fr}`;
  }

  return (
    <>
      {
        displayRefuseReasonModal && (
          <Modal
            visible={displayRefuseReasonModal}
            onOk={() => setDisplayRefuseReasonModal(false)}
            closable={false}
            maskClosable={false}
            footer={null}
          >
            <Text size={14} style={{ marginBottom: 10 }}>Indiquez la raison de votre demande de modification ci-dessous :</Text>
            <Input.TextArea onChange={(e) => setRefuseReason(e.target.value)}/>
            <Button disabled={!refuseReason || refuseReason.length < 3} type="primary" style={{ marginTop: 10 }} onClick={() => handleOnRefuse(props.mount)}>Enregistrer</Button>
          </Modal>
        )
      }

      {
        loading && (
          
          <Modal
            visible={loading}
            maskClosable={false}
            closable={false}
            footer={null}
          >
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
              <Spin />
              <Text>Veuillez patienter quelques instants... </Text>
            </div>
          </Modal>
        )
      }

      <CloseCircleFilled style={{ color: 'white', position: 'absolute', right: 10, top: 10, zIndex: 99999, fontSize: 26 }}  onClick={props.handleOnClose} />
      <StyledLayer onClick={props.handleOnClose} />
      <StyledContent>
        <div style={{ width: '75%', margin: 'auto'}}>
          
          <Text size={14} color="white" align="center" style={{ marginBottom: 10 }}>{mountName}</Text>

          <img src={imgSrc} style={{ width: '100%' }} alt={props.title} />
          
          <Text onClick={() => props.handleOnDownload(imgSrc)} underline color="white" align="center" style={{ cursor: 'pointer', marginTop: 20 }}>Télécharger</Text>
          
          <div style={{ display: 'flex', flexDirection: 'column', width: 200, margin: 'auto', marginTop: 10 }}>
            <Button type="primary" style={{ marginTop: 10 }} onClick={() => handleOnAccept(props.mount)}>Accepter</Button>
            <Button type="danger" style={{ marginTop: 10 }} onClick={() => setDisplayRefuseReasonModal(true)}>Demander une modification</Button>
          </div>

        </div>
      </StyledContent>
    </>
  )
}

export default IkomMountQuotationsModal;